import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import { Icon } from '../Icon';
import { ModalHeader, ModalTitle } from '../Modal';
import { IAlertHeaderProps } from './AlertProps';

const StyledModalHeader = styled(ModalHeader)`
  padding-bottom: ${toRem(theme.space.md)};
`;

const IconContainer = styled.div<Partial<IAlertHeaderProps>>`
  position: relative;
  justify-content: center;
  align-items: center;
  margin-bottom: ${toRem(theme.space.xl)};

  ${({ size }) => css`
    width: ${toRem(size)};
    height: ${toRem(size)};
  `}

  svg {
    position: relative;
    fill: ${({ iconFill }) => iconFill || theme.color.warning[50]};
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 50%;
    background-color: ${({ iconFill }) => iconFill || theme.color.warning[50]};
    opacity: 0.15;
  }
`;

const AlertHeader = ({ dataCy = 'alert-header', icon = 'Caution', iconFill = theme.color.warning[50], hideIcon = false, title, size = 55 }: IAlertHeaderProps) => (
  <StyledModalHeader data-cy={dataCy}>
    {!hideIcon && (
      <IconContainer iconFill={iconFill} size={size + 33}>
        <Icon icon={icon} width={size} height={size} style={{ top: icon === 'Caution' ? toRem(-3.75) : 0 }} dataCy="alert-icon" />
      </IconContainer>
    )}
    {title && <ModalTitle>{title}</ModalTitle>}
  </StyledModalHeader>
);

export default AlertHeader;
